import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, ExternalLink } from 'lucide-react';
import TaskPlanner from './TaskPlanner';
import './TaskPlannerModal.css';

const TaskPlannerModal = ({ open, onClose }) => {
  const [view, setView] = useState('planner');

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  useEffect(() => { if (!open) setView('planner'); }, [open]);

  if (!open) return null;

  const isEditing = view === 'editor';

  return (
    <div className={`rstp-modal ${isEditing ? 'rstp-modal--editing' : ''}`}
         role="dialog" aria-modal="true" aria-label="Tasks">
      <div className="rstp-modal__backdrop" onClick={onClose} aria-hidden="true" />
      <div className="rstp-modal__sheet">
        <div className="rstp-modal__grip" aria-hidden="true" />

        {!isEditing && (
          <header className="rstp-modal__header">
            <span className="rstp-modal__heading">Tasks</span>
            <div className="rstp-modal__actions">
              <Link
                to="/utilities/tasks"
                className="rstp-modal__open"
                onClick={onClose}
                title="Open full page"
              >
                <ExternalLink size={14} aria-hidden="true" />
                <span>Open page</span>
              </Link>
              <button
                type="button"
                className="rstp-modal__close"
                onClick={onClose}
                aria-label="Close"
              >
                <X size={18} aria-hidden="true" />
              </button>
            </div>
          </header>
        )}

        <div className="rstp-modal__body">
          <TaskPlanner
            compact
            onViewChange={({ view: v }) => setView(v)}
          />
        </div>
      </div>
    </div>
  );
};

export default TaskPlannerModal;
